import { BaseView } from "./base-view";
/**
 * Represents a view of an array model
 * @class ArrayView
 * @extends BaseView
 */
export class ArrayView extends BaseView {
    constructor(model) {
        super();
        this.model = model;
    }
    createChild(id, item, before) {
        super.createChild(item, item, before || this.$.nodes.get(id));
    }
    $ready() {
        this.model.forEach(item => {
            this.createChild(item, item);
        });
        super.$ready();
    }
}
